import React from 'react';
export default function Blockquote(props) {
    return React.createElement("blockquote", null, props.children);
}
//# sourceMappingURL=blockquote.js.map